/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * A media source that is interrupted right now, with elapsed outage seconds.
 */
export interface OralExamMediaSourceCurrent {
  source: string;
  sinceSeconds: number;
}
